<mat-card appearance="outlined">

    <mat-card-header>
        <mat-card-title>Equipment Data</mat-card-title>
    </mat-card-header>

    <mat-card-content>

        <div class="mt1">

            <form (formValid)="formValid.set($event)"
                  (formDirty)="formDirty.set($event)">

                <div>
                    <mat-form-field class="w-full">
                        <mat-label>select equipment</mat-label>
                        <mat-select (selectionChange)="onEquipmentChange($event)">
                            @for (equipment of vm.equipments; track equipment.value) {
                            <mat-option [value]="equipment.value">{{equipment.label}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

                @if (vm.showCables) {<app-equipment-data-cables></app-equipment-data-cables>}
                @if (vm.showPV) {<app-equipment-data-pv></app-equipment-data-pv>}

            </form>
        </div>

    </mat-card-content>


</mat-card>
